import { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

export default function AdminApp() {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem('adminAuth') === 'true'
  );

  const handleLogin = () => {
    localStorage.setItem('adminAuth', 'true');
    setLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    setLoggedIn(false);
  };

  if (!loggedIn) {
    return (
      <AdminLogin
        onLoginSuccess={handleLogin}
        onExit={() => window.location.href = '/'}
      />
    );
  }

  return <AdminPanel onLogout={handleLogout} />;
}




